const sentenceCase = (word = '') => {
  const listOfLetters = word.split('');
  listOfLetters[0] = listOfLetters[0].toUpperCase();
  return listOfLetters.join('');
};

export { sentenceCase };
